import { missingInput, divisionByZero } from '../warnings';
import { formulaOk, formulaUnknown, type FormulaResult } from './types';

/**
 * SPEC-008 §16/§37/METRIC-REQ-004 — node conversion = exits / entries.
 * `entries = 0` must never produce a fake `0/0` conversion.
 */
export function conversion(entries: number | null, exits: number | null): FormulaResult {
  const explanation = {
    metric: 'conversion',
    formula: 'exits / entries',
    inputs: { entries, exits },
    result: null,
  };
  if (entries === null || exits === null) {
    return formulaUnknown(explanation, [missingInput('Entries and exits are both required to calculate conversion.')]);
  }
  if (entries === 0) {
    return formulaUnknown(explanation, [divisionByZero('Conversion is undefined when entries is zero.')]);
  }
  return formulaOk(exits / entries, { ...explanation, result: exits / entries }, []);
}
